// extracted by mini-css-extract-plugin
export default {"title":"title___Ht6EF","alertWrapper":"alertWrapper___Loyzv","applyButton":"applyButton___nprND"};